export const FETCH_AI_CONVERSATIONS =
  "app/AiConversations/FETCH_AI_CONVERSATIONS";
export const FETCH_AI_CONVERSATIONS_SUCCESS =
  "app/AiConversations/FETCH_AI_CONVERSATIONS_SUCCESS";
export const FETCH_AI_CONVERSATIONS_FAILURE =
  "app/AiConversations/FETCH_AI_CONVERSATIONS_FAILURE";

export const FETCH_AI_CONVERSATION =
  "app/AiConversations/FETCH_AI_CONVERSATION";
export const FETCH_AI_CONVERSATION_SUCCESS =
  "app/AiConversations/FETCH_AI_CONVERSATION_SUCCESS";
export const FETCH_AI_CONVERSATION_FAILURE =
  "app/AiConversations/FETCH_AI_CONVERSATION_FAILURE";

export const CREATE_AI_CONVERSATION =
  "app/AiConversations/CREATE_AI_CONVERSATION";
export const CREATE_AI_CONVERSATION_SUCCESS =
  "app/AiConversations/CREATE_AI_CONVERSATION_SUCCESS";
export const CREATE_AI_CONVERSATION_FAILURE =
  "app/AiConversations/CREATE_AI_CONVERSATION_FAILURE";

export const SEND_AI_MESSAGE = "app/AiConversations/SEND_AI_MESSAGE";
export const SEND_AI_MESSAGE_SUCCESS =
  "app/AiConversations/SEND_AI_MESSAGE_SUCCESS";
export const SEND_AI_MESSAGE_FAILURE =
  "app/AiConversations/SEND_AI_MESSAGE_FAILURE";

export const APPEND_OPTIMISTIC_AI_MESSAGE =
  "app/AiConversations/APPEND_OPTIMISTIC_AI_MESSAGE";
export const RESET_AI_CONVERSATION_STATE =
  "app/AiConversations/RESET_AI_CONVERSATION_STATE";

// AI Logs review — fetch all conversations for a resident + their messages.
export const FETCH_AI_LOGS = "app/AiConversations/FETCH_AI_LOGS";
export const FETCH_AI_LOGS_SUCCESS =
  "app/AiConversations/FETCH_AI_LOGS_SUCCESS";
export const FETCH_AI_LOGS_FAILURE =
  "app/AiConversations/FETCH_AI_LOGS_FAILURE";
